module.exports = __webpack_public_path__ + "static/DifficultyDifficultGames1-4e145b2fb4b50f4ed23e71e67d48dea3.webp";